import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import { CREATIVE_NAMES, DISPLAY_SKYBOX_AD_FIELDS } from "./definitions";
import BaseCreativeControls from "./BaseCreativeControls";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "primereact/button";

const CREATIVE_TYPE = CREATIVE_NAMES.DISPLAY_SKYBOX;
const SWITCH_SECTION_STYLES = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5em;
    padding: 6px;
    margin: 10px 0;
    background-color: #e6edf2;
    .label {
        font-weight: bold;
    }
`;


export default function DisplaySkybox({
    displayCreativeUrl,
    collapsedCreaiveUrl,
    mobileCreativeUrl,
    handleChange,
    currentCustomer,
    impressionTag,
    clickTag,
    adServingType,
    disallowCollapse
}) {
    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                creativeType={CREATIVE_TYPE}
                impressionTag={impressionTag}
            >

                <div css={SWITCH_SECTION_STYLES}>
                    <div className="flex flex-col-center">
                        <Button
                            className="p-button-outlined p-button-icon-only p-button-info p-button-rounded"
                            icon="pi pi-info"
                            iconPos="right"
                            style={{ width: '20px', height: '20px' }}
                            tooltip={`When this option is enabled the creative will have a \"Collapse\" button available to dismiss the creative from view.`}
                        />
                        &nbsp;
                        <span className="label">Is Collapsible By User?</span>
                    </div>
                    <InputSwitch
                        checked={!disallowCollapse}
                        name={DISPLAY_SKYBOX_AD_FIELDS.disallowCollapse}
                        onChange={e => {
                            handleChange(e, !e.value, CREATIVE_TYPE)
                        }}
                    />
                </div>
                <AssetInputOrUploadSection
                    inputValue={displayCreativeUrl}
                    inputLabel="Desktop Banner"
                    inputName={DISPLAY_SKYBOX_AD_FIELDS.displayCreativeUrl}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                    tooltip="1456x180 image"
                />
                {
                    !disallowCollapse && (
                        <AssetInputOrUploadSection
                            inputValue={collapsedCreaiveUrl}
                            inputLabel="Collapsed Desktop Banner"
                            inputName={DISPLAY_SKYBOX_AD_FIELDS.collapsedCreaiveUrl}
                            inputChangeHandler={handleChange}
                            inputAdtype={CREATIVE_TYPE}
                            isRequired={false}
                            currentCustomer={currentCustomer}
                            accept="image/*"
                            defaultExtension="jpeg"
                            tooltip={"525x250 image"}
                        />
                    )
                }
                <AssetInputOrUploadSection
                    inputValue={mobileCreativeUrl}
                    inputLabel="Mobile Banner"
                    inputName={DISPLAY_SKYBOX_AD_FIELDS.mobileCreativeUrl}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                    tooltip="2:1 ratio image, e.g. 360x180 or 400x200 etc"
                />
            </BaseCreativeControls>
        </>
    );
}